import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import FurnitureCalculator from '../FurnitureCalculator';

const Calculator = () => {
  return (
    <Box sx={{ minHeight: '100vh', pt: 12, pb: 10, bgcolor: '#0f2832' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 2, fontWeight: 'bold', color: 'white', fontSize: { xs: '2rem', md: '3rem' } }}
        >
          Umzugskalkulator
        </Typography>
        <Typography
          variant="h6"
          align="center"
          sx={{ mb: 6, color: '#55d6dc', opacity: 0.95 }}
        >
          Berechnen Sie Ihr Umzugsvolumen und erhalten Sie ein kostenloses Angebot
        </Typography>

        <Box>
          <FurnitureCalculator />
        </Box>
      </Container>
    </Box>
  );
};

export default Calculator;